import axios from "axios";
import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet-async";
import { STANDARD_ERRORS_WAY } from "../../../../utils/consts";
import { parseAxiosError } from "../../../../utils/response";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import Notification from "../../../elements/notification/Notification";
import ProjectApiKey from "./projectApiKey/ProjectApiKey";
import ProjectConnectionsContainer from "./projectConnections/ProjectConnectionsContainer";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import TabPanel from "../../../elements/tab/materialTabPanel";
import ProjectIpWhitelistContainer from "./projectIpWhitelist/ProjectIpWhitelistContainer";
import ProjectWebhooksContainer from "./projectWebhooks/ProjectWebhooksContainer";
import { useHistory } from "react-router-dom";
import queryString from "query-string";
import { useTranslation } from "react-i18next";

import { StyledProjectDetailsWrapper } from "./styledProjectDetails";
import { StyledTabsBody, StyledTabsHead, StyledTabsWrapper } from "../../../styles/styledTabs";

const DEFAULT_TAB = "api-keys";

const ProjectDetailsContainer = ({ match }) => {
  const { t } = useTranslation("projectsPage");
  const history = useHistory();
  let queryParams = queryString.parse(history.location.search);

  const [project, setProject] = useState({});
  const [notification, setNotification] = useState({
    visible: false,
    type: "",
    message: ""
  });

  const fetchProject = () => {
    axios.get("/api/projects/" + match.params.id, userAuthenticationConfig()).then(response => {
      if (response.status === 200) {
        setProject(response.data);
      }
    }).catch(error => {
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  const urlForTabs = () => {
    if (!queryParams.currentTab) {
      return 0;
    }

    switch (queryParams.currentTab) {
      case "api-keys": {
        return 0;
      }
      case "ip-whitelist": {
        return 1;
      }
      case "connection-list": {
        return 2;
      }
      case "webhooks": {
        return 3;
      }
    }
  };

  const tabValue = urlForTabs();

  const handleChange = (event, newValue) => {
    if (queryParams.currentTab !== newValue) {
      history.push("?currentTab=" + newValue);
    }
  };

  useEffect(() => {
    fetchProject();
  }, []);

  return (
    <>
      <Notification
        notification={notification}
        setNotification={setNotification}
      />
      <StyledProjectDetailsWrapper>
        <Helmet>
          <title>{t("details.meta.title")}</title>
        </Helmet>
        <StyledTabsWrapper>
          <StyledTabsHead className="tab-head">
            <h4 className="tab-head__title">
              {t("details.tabs.title")}
            </h4>
            <Tabs
              value={queryParams?.currentTab ?? DEFAULT_TAB}
              indicatorColor="secondary"
              onChange={handleChange}
              orientation="vertical"
              className="tab-head-buttons"
            >
              <Tab label={t("details.tabs.apiKey")} value="api-keys" />
              <Tab label={t("details.tabs.ipWhitelist")} value="ip-whitelist" />
              <Tab label={t("details.tabs.connections")} value="connection-list" />
              <Tab label="Webhooks" value="webhooks" />
            </Tabs>
          </StyledTabsHead>
          <StyledTabsBody className="tab-body">
            <TabPanel
              value={tabValue}
              index={0}
            >
              <ProjectApiKey
                t={t}
                projectId={match.params.id}
                project={project}
                setProject={setProject}
              />
            </TabPanel>
            <TabPanel
              value={tabValue}
              index={1}
            >
              <ProjectIpWhitelistContainer
                t={t}
                projectId={match.params.id}
                project={project}
                notification={notification}
                setNotification={setNotification}
              />
            </TabPanel>
            <TabPanel
              value={tabValue}
              index={2}
            >
              <ProjectConnectionsContainer
                t={t}
                projectId={match.params.id}
              />
            </TabPanel>
            <TabPanel
              value={tabValue}
              index={3}
            >
              <ProjectWebhooksContainer
                t={t}
                projectId={match.params.id}
              />
            </TabPanel>
          </StyledTabsBody>
        </StyledTabsWrapper>
      </StyledProjectDetailsWrapper>
    </>
  );
};

export default ProjectDetailsContainer;